module.exports = __webpack_public_path__ + "img/GGY.6defde85.svg";